<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        immediate: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        update() {
            const document = this.$el.ownerDocument;
            document.body.prepend(this.$el);
        },
    },
    mounted() {
        if (this.immediate) {
            this.update();
        }
    },
};
</script>
